import { render } from "./ModelMenu.vue?vue&type=template&id=92213fe0&ts=true"
import script from "./ModelMenu.vue?vue&type=script&lang=ts"
export * from "./ModelMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__